import React from 'react';
import './MyOrder.css'

const MyOrder = () => {
    return (
        <div className="myOrder-container">
            <div>
                <h1>Booked Itams Route.</h1>
            </div>
        </div>
    );
};

export default MyOrder;